import React, { useEffect, useState, useRef } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { AiFillWarning, AiTwotoneMinusCircle } from "react-icons/ai";
import { MdNotificationsActive } from "react-icons/md";
import {
  FaEdit,
  FaBatteryHalf,
  FaPlusSquare,
  FaAsymmetrik,
} from "react-icons/fa";
import { BsTrash } from "react-icons/bs";
import { Card } from "primereact/card";
import ProjectService from "./ProjectService";
import SignalCellular0BarIcon from "@mui/icons-material/SignalCellular0Bar";
import SignalCellular1BarIcon from "@mui/icons-material/SignalCellular1Bar";
import SignalCellular2BarIcon from "@mui/icons-material/SignalCellular2Bar";
import SignalCellular3BarIcon from "@mui/icons-material/SignalCellular3Bar";
import SignalCellular4BarIcon from "@mui/icons-material/SignalCellular4Bar";

import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import DeviceAssign from "./DeviceAssign";
import { confirmDialog } from "primereact/confirmdialog";
import ProjectDropdown from "./ProjectDropdown";
import UpdateStation from "./UpdateStation";
import { Tooltip } from "react-tooltip";
var moment = require("moment-timezone");

type InfoProps = {
  switchTab: () => void;
};
const Info = (props: InfoProps) => {
  const toast = useRef<any>(null);
  const navigate = useNavigate();
  const { projectId } = useParams<any>();
  let location = useLocation();
  const { t } = useTranslation();

  const [userId, setUserId] = useState<number>();
  const [assignedDevice, setAssignedDevice] = useState<any>([]);
  const [assignedDeviceProjects, setAssignedDeviceProjects] = useState<any>([]);
  const [deletedProjects, setDeletedProjects] = useState<any>([]);
  const [isDeletedProject, setIsDeletedProject] = useState<boolean>(true);
  const [unAssignedDevice, setUnAssignedDevice] = useState<any>([]);
  const [updateComponent, setUpdateComponent] = useState<number>(0);
  const [projectName, setProjectName] = useState<string>("");
  const [deviceDialogue, setDeviceDialogue] = useState<boolean>(false);
  const [deviceId, setDeviceId] = useState<string>("");
  const [isAllProject, setIsAllProject] = useState<boolean>(true);
  const projectService = new ProjectService();
  const [isUpdateStation, setIsUpdateStation] = useState<boolean>(false);
  const [updateStationData, setUpdateStationData] = useState<any>();
  const targetTimeZone =
    localStorage.getItem("timezone") && localStorage.getItem("timezone");

  const headerInfo = (name: string) => {
    let div: any;
    div = (
      <div>
        <AiTwotoneMinusCircle
          color="green"
          className="mt-1 pt-1"
          fontSize={"18px"}
        />{" "}
        {name}
      </div>
    );

    return div;
  };

  const header3 = <div className="mt-1 pt-1">{t("warnign_alarm")}</div>;

  const deviceStatus = (status: string) => {
    let div: any = "";
    if (status === "running") {
      div = (
        <AiTwotoneMinusCircle
          color="green"
          className="mt-1"
          fontSize={"18px"}
        />
      );
    } else if (status === "not running") {
      div = (
        <AiTwotoneMinusCircle
          color="yellow"
          className="mt-1"
          fontSize={"18px"}
        />
      );
    }
    return div;
  };

  const showSuccess = (message: string) => {
    toast.current.show({
      severity: "success",
      summary: "Confirmation Message",
      detail: message,
      life: 3000,
    });
  };

  const showError = (message: string) => {
    toast.current.show({
      severity: "error",
      summary: "Error Message",
      detail: message,
      life: 3000,
    });
  };

  const confirmDelete = (projectId: number, did: string) => {
    confirmDialog({
      message: t("delete_dialoge_message") + ` ${did}`,
      header: t("delete_confirmation"),
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: t("yes"),
      rejectLabel: t("no"),
      accept: () => {
        projectService
          .deleteProjectDevice(projectId, did, userId)
          .then((response) => {
            if (response === 200) {
              showSuccess(t("device_deleted"));
              setUpdateComponent(updateComponent + 1);
            } else {
              showError(t("something_wrong"));
            }
          });
      },
    });
  };

  const confirmRestoreProject = (projectId: string, project_name: string) => {
    confirmDialog({
      message: t("restore_project") + ` ${project_name}`,
      header: t("restore_project_header"),
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: t("yes"),
      rejectLabel: t("no"),
      accept: () => {
        const body = {
          user_id: localStorage.getItem("userId"),
          project_id: projectId,
        };
        projectService.updateDeletedProjects(body).then((response) => {
          if (response === 200) {
            showSuccess(t("restore_project_message"));
            setUpdateComponent(updateComponent + 1);
            window.location.reload();
          } else {
            showError(t("something_wrong"));
          }
        });
      },
    });
  };

  const getDetails = () => {
    projectService.getUserDetails().then((resp) => {
      setUserId(resp["id"]);
      localStorage.setItem("username", resp["username"].trim());
      localStorage.setItem("email", resp["email"]);
      localStorage.setItem("keycloak_id", resp["keycloak_id"]);
      localStorage.setItem("userId", resp["id"]);
      if (projectId === undefined) {
        setProjectName(t("all_projects"));
        setIsAllProject(true);
        projectService.getAssignedDevices(resp["id"], "").then((response) => {
          setAssignedDeviceProjects(response);
        });
      } else {
        projectService
          .getSingleAssignedDevice(projectId, resp["id"], "project-page")
          .then((response) => {
            setAssignedDevice(response);
            setProjectName(response["project"]["project_name"]);
            setIsAllProject(false);
          });
      }
      projectService.getUnAssignedDevices(resp["id"]).then((response) => {
        setUnAssignedDevice(response);
      });
    });
    projectService.getDeletedProjects().then((response) => {
      setDeletedProjects(response);
    });
  };

  useEffect(() => {
    getDetails();
    localStorage.removeItem("tabVal");
    i18n.changeLanguage(localStorage.getItem("lang")!);
  }, [updateComponent, location.pathname, i18n.language]);

  const getSignalValues = (details: any) => {
    if (details["mdm_act"] === 99) {
      if (details["mdm_act"] > -55) {
        return <img src={"/images/wifi-icons/wifi-full.png"} />;
      } else if (details["mdm_act"] < -55 && details["mdm_act"] > -70) {
        return <img src={"/images/wifi-icons/wifi-3.png"} />;
      } else if (details["mdm_act"] < -70 && details["mdm_act"] > -80) {
        return <img src={"/images/wifi-icons/wifi-2.png"} />;
      } else if (details["mdm_act"] < -80 && details["mdm_act"] > -90) {
        return <img src={"/images/wifi-icons/wifi-1.png"} />;
      } else if (details["mdm_act"] < -80) {
        return <img src={"/images/wifi-icons/wifi-0.png"} />;
      }
    } else if (details["mdm_act"] === 3 || details["mdm_act"] === 7) {
      if (details["mdm_act"] >= 20) {
        return <SignalCellular4BarIcon />;
      } else if (details["mdm_act"] >= 15 && details["mdm_act"] < 20) {
        return <SignalCellular3BarIcon />;
      } else if (details["mdm_act"] >= 10 && details["mdm_act"] < 15) {
        return <SignalCellular2BarIcon />;
      } else if (details["mdm_act"] > 0 && details["mdm_act"] < 10) {
        return <SignalCellular2BarIcon />;
      } else if (details["mdm_act"] <= 0) {
        return <SignalCellular0BarIcon />;
      }
    } else {
      return <SignalCellular0BarIcon />;
    }
  };

  const getStatusColor: any = (timestamp: any) => {
    const givenTime: Date = new Date(timestamp);
    const currentTime: Date = new Date();
    const differenceInMillis: number =
      currentTime.getTime() - givenTime.getTime();
    const differenceInHours: number = differenceInMillis / (1000 * 60 * 60);
    if (Math.abs(differenceInHours) === 2) {
      return "orange";
    } else if (Math.abs(differenceInHours) < 2) {
      return "green";
    } else {
      return "red";
    }
  };
  return (
    <>
      <Card
        // title={getDropdown}
        id="projectsInfo"
        style={{ margin: "0.5em auto", overflowX: "auto" }}
      >
        <Toast ref={toast} />
        <div className="grid mt-4">
          <div className="col-12 lg:col-12">
            {isAllProject ? (
              <>
                {" "}
                <Accordion multiple activeIndex={[0]}>
                  {assignedDeviceProjects.map((device: any, i: number) => {
                    return (
                      <AccordionTab
                        header={headerInfo(device["project"]["project_name"])}
                        key={i}
                      >
                        {device["project_devices"].map(
                          (project_device: any, i: number) => {
                            return (
                              <div
                                className="flex justify-content-between align-items-center single-alert"
                                key={i}
                              >
                                <div
                                  className="flex align-items-center"
                                  style={{ minWidth: "200px" }}
                                >
                                  <AiTwotoneMinusCircle
                                    color={getStatusColor(
                                      project_device["timestamp"]
                                    )}
                                    className="mt-1"
                                    fontSize={"18px"}
                                  />
                                  <p
                                    className="ml-2 eventSwitch"
                                    onClick={() => {
                                      let json = {
                                        name: `${project_device["station"]} | ${device["project"]["project_name"]}`,
                                        value: `${project_device["station"]}~${project_device["project_id"]}`,
                                      };
                                      localStorage.setItem(
                                        "eventSelect",
                                        JSON.stringify(json)
                                      );
                                      props.switchTab();
                                    }}
                                  >
                                    {project_device["did"]}
                                  </p>
                                </div>
                                <div
                                  style={{
                                    marginLeft: "20px",
                                    minWidth: "200px",
                                  }}
                                >
                                  <p
                                    className="eventSwitch"
                                    onClick={() => {
                                      let json = {
                                        name: `${project_device["station"]} | ${device["project"]["project_name"]}`,
                                        value: `${project_device["station"]}~${project_device["project_id"]}`,
                                      };
                                      localStorage.setItem(
                                        "eventSelect",
                                        JSON.stringify(json)
                                      );
                                      props.switchTab();
                                    }}
                                  >
                                    {project_device["station"]}
                                  </p>
                                </div>
                                <div>
                                  <p>Vib3D</p>
                                </div>
                                <div>
                                  <p>
                                    {project_device["timestamp"] !==
                                      undefined &&
                                    project_device["timestamp"] !== null
                                      ? moment(project_device["timestamp"])
                                          .tz(targetTimeZone)
                                          .format("YYYY-MM-DD HH:mm:ss")
                                      : " ---- "}
                                  </p>
                                </div>
                                <div>
                                  {project_device["details"] ? (
                                    getSignalValues(project_device["details"])
                                  ) : (
                                    <img
                                      src={"/images/wifi-icons/wifi-0.png"}
                                      style={{ opacity: "0.5" }}
                                    />
                                  )}
                                  {project_device["details"] &&
                                  project_device["details"]["rec_files"] ===
                                    0 ? (
                                    <span
                                      className="ml-1"
                                      style={{ fontWeight: 600 }}
                                    >
                                      100&#37;
                                    </span>
                                  ) : (
                                    <span
                                      className="ml-1"
                                      style={{
                                        fontWeight: 600,
                                        opacity: "0.5",
                                      }}
                                    >
                                      0&#37;
                                    </span>
                                  )}
                                </div>
                                <div>
                                  <Tooltip
                                    id="update-station"
                                    style={{ zIndex: "1000" }}
                                  />
                                  <FaAsymmetrik
                                    className="edit-icon mx-2"
                                    onClick={() => {
                                      setIsUpdateStation(true);
                                      setUpdateStationData(project_device);
                                    }}
                                    data-tooltip-id={"update-station"}
                                    data-tooltip-content={t("update_station")}
                                  />
                                  <Tooltip
                                    id="edit-device"
                                    style={{ zIndex: "1000" }}
                                  />
                                  <FaEdit
                                    className="edit-icon mx-2"
                                    onClick={() => {
                                      localStorage.setItem(
                                        "redirect-url",
                                        window.location.pathname
                                      );
                                      navigate(
                                        "/device/" +
                                          project_device["did"] +
                                          "/" +
                                          device["project"]["project_name"]
                                      );
                                    }}
                                    data-tooltip-id={"edit-device"}
                                    data-tooltip-content={t("edit_devices")}
                                  />
                                  <Tooltip
                                    id="delete"
                                    style={{ zIndex: "1000" }}
                                  />
                                  <BsTrash
                                    className="trash-icon mx-1"
                                    onClick={() => {
                                      confirmDelete(
                                        device["project"]["id"],
                                        project_device["did"]
                                      );
                                    }}
                                    data-tooltip-id={"delete"}
                                    data-tooltip-content={t("delete")}
                                  />
                                </div>
                              </div>
                            );
                          }
                        )}
                      </AccordionTab>
                    );
                  })}
                  (
                  <AccordionTab header={t("unassigned")}>
                    {unAssignedDevice.map((device: any, i: any) => {
                      return (
                        <div
                          className="flex justify-content-between align-items-center single-alert"
                          key={i}
                        >
                          <div
                            className="flex align-items-center"
                            style={{ minWidth: "200px" }}
                          >
                            <AiTwotoneMinusCircle
                              color="green"
                              className="mt-1"
                              fontSize={"18px"}
                            />
                            <p className="ml-2">{device["did"]}</p>
                          </div>
                          <div
                            style={{ marginLeft: "20px", minWidth: "200px" }}
                          >
                            <p>{device["did"]}</p>
                          </div>
                          <div>
                            <p>Vib3D</p>
                          </div>
                          <div>
                            <p className="text-bold">
                              {device["rent_to"]} 00:00:00
                            </p>
                          </div>
                          <div>
                            {/*<i className="pi pi-clock edit-icon mx-2"></i>*/}
                            <i className="pi pi-wifi edit-icon mx-2"></i>
                            <FaBatteryHalf className="edit-icon mx-2" />
                            {/*<i className="pi pi-percentage edit-icon mx-2"></i>*/}
                          </div>
                          <div>
                            <Tooltip id="assign-project" />
                            <FaPlusSquare
                              className="edit-icon mx-2"
                              onClick={() => {
                                setDeviceId(device["did"]);
                                setDeviceDialogue(true);
                              }}
                              data-tooltip-id={"assign-project"}
                              data-tooltip-content={t("assign_devices")}
                            />
                            <FaEdit
                              className="edit-icon mx-2"
                              onClick={() => {
                                navigate("/all-devices/");
                              }}
                              data-tooltip-id={"edit-device"}
                              data-tooltip-content={t("edit_devices")}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </AccordionTab>
                  {isDeletedProject && (
                    <AccordionTab header={t("deleted_project")}>
                      {deletedProjects.map((project: any, i: any) => {
                        return (
                          <div
                            className="flex justify-content-between align-items-center single-alert"
                            key={i}
                          >
                            <div className="flex align-items-center">
                              <p className="ml-2">{project["project_name"]}</p>
                            </div>
                            <div>
                              <Tooltip
                                id="restore-project"
                                style={{ zIndex: "1000" }}
                              />
                              <i
                                className="pi pi-refresh mx-2"
                                onClick={() => {
                                  confirmRestoreProject(
                                    project["id"],
                                    project["project_name"]
                                  );
                                }}
                                data-tooltip-id={"restore-project"}
                                data-tooltip-content={t(
                                  "restore_project_header"
                                )}
                              />
                              <i></i>
                            </div>
                          </div>
                        );
                      })}
                    </AccordionTab>
                  )}
                </Accordion>
              </>
            ) : (
              <>
                <Accordion multiple activeIndex={[0]}>
                  <AccordionTab header={projectName}>
                    {assignedDevice["project_devices"].map(
                      (project_device: any, i: number) => {
                        return (
                          <div
                            className="flex justify-content-between align-items-center single-alert"
                            key={i}
                          >
                            <div className="flex align-items-center">
                              <AiTwotoneMinusCircle
                                color={getStatusColor(
                                  project_device["timestamp"]
                                )}
                                className="mt-1"
                                fontSize={"18px"}
                              />
                              <p
                                className="ml-2 eventSwitch"
                                onClick={() => {
                                  let json = {
                                    name: `${project_device["station"]} | ${projectName}`,
                                    value: `${project_device["station"]}~${project_device["project_id"]}`,
                                  };
                                  localStorage.setItem(
                                    "eventSelect",
                                    JSON.stringify(json)
                                  );
                                  props.switchTab();
                                }}
                              >
                                {project_device["did"]}
                              </p>
                            </div>
                            <div
                              style={{ marginLeft: "20px", minWidth: "200px" }}
                            >
                              <p
                                className="eventSwitch"
                                onClick={() => {
                                  let json = {
                                    name: `${project_device["station"]} | ${projectName}`,
                                    value: `${project_device["station"]}~${project_device["project_id"]}`,
                                  };
                                  localStorage.setItem(
                                    "eventSelect",
                                    JSON.stringify(json)
                                  );
                                  props.switchTab();
                                }}
                              >
                                {project_device["station"]}
                              </p>
                            </div>
                            <div>
                              <p>Vib3D</p>
                            </div>
                            <div>
                              <p>
                                {project_device["timestamp"] !== undefined &&
                                project_device["timestamp"] !== null
                                  ? moment(project_device["timestamp"])
                                      .tz(targetTimeZone)
                                      .format("YYYY-MM-DD HH:mm:ss")
                                  : " ---- "}
                              </p>
                            </div>
                            <div>
                              {project_device["details"] ? (
                                getSignalValues(project_device["details"])
                              ) : (
                                <img
                                  src={"/images/wifi-icons/wifi-0.png"}
                                  style={{ opacity: "0.5" }}
                                />
                              )}
                              {project_device["details"] &&
                              project_device["details"]["rec_files"] === 0 ? (
                                <span
                                  className="ml-1"
                                  style={{ fontWeight: 600 }}
                                >
                                  100&#37;
                                </span>
                              ) : (
                                <span
                                  className="ml-1"
                                  style={{ fontWeight: 600, opacity: "0.5" }}
                                >
                                  0&#37;
                                </span>
                              )}
                            </div>
                            <div>
                              <FaAsymmetrik
                                className="edit-icon mx-2"
                                onClick={() => {
                                  setIsUpdateStation(true);
                                  setUpdateStationData(project_device);
                                }}
                              />
                              <FaEdit
                                className="edit-icon mx-2"
                                onClick={() => {
                                  localStorage.setItem(
                                    "redirect-url",
                                    window.location.pathname
                                  );
                                  navigate(
                                    "/device/" +
                                      project_device["did"] +
                                      "/" +
                                      assignedDevice["project"]["project_name"]
                                  );
                                }}
                              />
                              <BsTrash
                                className="trash-icon mx-1"
                                onClick={() => {
                                  confirmDelete(
                                    assignedDevice["project"]["id"],
                                    project_device["did"]
                                  );
                                }}
                              />
                            </div>
                          </div>
                        );
                      }
                    )}
                  </AccordionTab>

                  <AccordionTab header={t("unassigned")}>
                    {unAssignedDevice.map((device: any, i: any) => {
                      return (
                        <div
                          className="flex justify-content-between align-items-center single-alert"
                          key={i}
                        >
                          <div className="flex align-items-center">
                            <AiTwotoneMinusCircle
                              color="green"
                              className="mt-1"
                              fontSize={"18px"}
                            />
                            <p className="ml-2">{device["did"]}</p>
                          </div>
                          <div>
                            <p className="text-bold">{device["rent_from"]}</p>
                          </div>
                          <div>
                            <p className="text-bold">{device["rent_to"]}</p>
                          </div>
                          <div>
                            <p>Vib3D</p>
                          </div>
                          <div>
                            <FaPlusSquare
                              className="edit-icon mx-2"
                              onClick={() => {
                                setDeviceId(device["did"]);
                                setDeviceDialogue(true);
                              }}
                            />

                            <FaEdit
                              className="edit-icon mx-2"
                              onClick={() => {
                                navigate("/all-devices/");
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </AccordionTab>

                  {isDeletedProject && (
                    <AccordionTab header={t("deleted_project")}>
                      {deletedProjects.map((project: any, i: any) => {
                        return (
                          <div
                            className="flex justify-content-between align-items-center single-alert"
                            key={i}
                          >
                            <div className="flex align-items-center">
                              <p className="ml-2">{project["project_name"]}</p>
                            </div>
                            <div>
                              <i
                                className="pi pi-refresh mx-2"
                                onClick={() => {
                                  confirmRestoreProject(
                                    project["id"],
                                    project["project_name"]
                                  );
                                }}
                              />
                              <i></i>
                            </div>
                          </div>
                        );
                      })}
                    </AccordionTab>
                  )}
                </Accordion>
              </>
            )}
          </div>

          {deviceDialogue && (
            <DeviceAssign
              modal={deviceDialogue}
              deviceId={deviceId}
              hidePopup={() => {
                setDeviceDialogue(false);
                setUpdateComponent(updateComponent + 1);
              }}
              onSuccess={() => {
                showSuccess(t("device_assigned"));
              }}
            />
          )}

          {isUpdateStation && (
            <UpdateStation
              modal={isUpdateStation}
              data={updateStationData}
              hidePopup={() => {
                setIsUpdateStation(false);
                setUpdateComponent(updateComponent + 1);
              }}
              showSuccess={() => {
                showSuccess(t("station_updated"));
              }}
            />
          )}
        </div>
      </Card>
    </>
  );
};

export default Info;
